
<template>
	<label class="radio " @click.prevent="toggle" :class="[{'on': isChecked}, typeClass,typestyle, {'is-disabled': disabled}]">
		<input type="radio" :name="name" :checked="isChecked" :value="val" ref="checkbox" :disabled="disabled">
		<i class="icon-hook"></i>
		<span><slot></slot></span>
	</label>
</template>
<script>
	export default {
		name: 'uRadio',
		props: {
			name: String,
			label: String,
			type: {
				type: String,
				default: 'primary',
			},
			tstyle: {
				type: String,
				default: 'blu-radio',
			},
			disabled: Boolean,
			checked: Boolean,
			value: {},
			types:{
				type:String,
				default: 'cardone',
			},
			val: [String, Number, Boolean,Object],
			onChange: {
				type: Function,
				default() {},
			},
		},

		data() {
			return {
				isChecked: this.checked,
				realVal: null,
			};
		},

		computed: {
			typeClass() {
				if (this.type) return `is-${this.type}`;
				return null;
			},
			typestyle() {
				if (this.tstyle) return `${this.tstyle}`;
				return null;
			},
			index() {
				return this.$parent.radioItems ? this.$parent.radioItems.indexOf(this) : null;
			},
		}, 

		watch: {
			value(val) {
				this.updateValue();
			},
			/*isChecked(val){
				this.isChecked = val;
			}*/
		},

		methods: {
			toggle() {
				if (this.isChecked) return;
				this.isChecked = !this.isChecked;
				if (this.$refs.checkbox.value && !this.isChecked) {
					this.realVal = '';
					this.$emit('input', this.realVal);
				} else if (this.$refs.checkbox.value && this.isChecked) {
					this.realVal = this.$refs.checkbox.value;
					this.$emit('input', this.realVal);
				} else if (!this.$refs.checkbox.value && this.isChecked) {
					this.realVal = true;
					this.$emit('input', this.realVal);
				} else {
					this.realVal = false;
					this.$emit('input', this.realVal);
				}

				this.$parent.isRadioGroup && this.$parent.updateValue(this.index);
				this.onChange(this.isChecked);
			},

		},

		mounted() {

			if (this.isChecked && !this.value) {
				this.$emit('input', this.$refs.checkbox.value);
			}
			if (this.value === this.val) {
				this.isChecked = true;
			}
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/uRadio/uRadio.vue